<template>
	<hr
		:class="{
			[$style['hr']]: true,
			[$style['hr--with-margin']]: withMargin,
			[$style['hr--expanded']]: expanded
		}"
	/>
</template>

<script>
export default {
	name: 'BaseHr',
	props: {
		expanded: {
			type: Boolean,
			default: false
		},
		withMargin: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style module lang="scss">




	.hr {
		display: block;
		border: 0;
		height: 1px;
		background: getColor(border);
		margin: 0;
		width: auto;

		&--with-margin {
			margin-top: $gutter * 2;
			margin-bottom: $gutter * 2;
		}

		&--expanded {
			margin-left: (-$gutter) * 3;
			margin-right: (-$gutter) * 3;

			@include media-breakpoint-only(xs) {
				margin-left: (-$gutter) * 2;
				margin-right: (-$gutter) * 2;
			}
		}
	}
</style>
